import { useCallback } from 'react';
import { useGlobalContext } from '../context/GlobalStore';
import apiClient from '../utils/apiClient';

const useFetchDevices = () => {
  const { setIsDeviceLoading, setDevices } = useGlobalContext();
  const fetchData = useCallback(
    async (accessToken, accountId) => {
      try {

        const response = await apiClient.post(
          '/devices',
          {
            action: 'get_devices',
            account_id: accountId,
          },
          {
            retryOptions: { maxRetries: 0 }
          },
          true
        );
        if (response) {
          setDevices(response);
        }
      } catch (error) {
        console.log('fetch devices', { error });
      } finally {
        setIsDeviceLoading(false);
      }
    },
    [setDevices, setIsDeviceLoading]
  );

  return fetchData;
};

export default useFetchDevices;
